/**
 * ローディングスピナーコンポーネント
 */

export function LoadingSpinner() {
  return (
    <div className="flex items-center justify-center p-8">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      <span className="sr-only">読み込み中...</span>
    </div>
  );
}
